import RestService from '@/services/RestService';

function create(payload) {
  return RestService.sendReq('post', 'demo-request', payload);
}

export default { create };
